module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('v-multiselect-listbox', {
    staticClass: "col-xs-12",
    attrs: {
      "options": _vm.setting.options,
      "reduce-display-property": function (option) { return option.label; },
      "reduce-value-property": function (option) { return option.value; },
      "search-input-class": _vm.setting.class,
      "search-options-placeholder": "搜尋...",
      "selected-options-placeholder": "搜尋..."
    },
    model: {
      value: (_vm.setting.choose),
      callback: function($$v) {
        _vm.$set(_vm.setting, "choose", $$v)
      },
      expression: "setting.choose"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear-both"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex mb-3 font-size-subtitle-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("\n      不套用門市\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "w-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("\n      套用門市\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aa2960f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/nd-trade-apply-store-multi-select-listbox.vue
// module id = 2408
// module chunks = 1